import { Record } from 'immutable';


export const Task = new Record({
  completed: false,
  key: null,
  title: null,
  timestamp: null
});



// WEBPACK FOOTER //
// ./src/tasks/task.js